var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboRedoSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.13105 9.60831C1.42661 11.1483 2.28994 12.5483 3.52661 13.5205C5.81327 15.325 8.72994 15.4105 10.9855 14.1583C11.1799 14.0494 11.2344 13.7928 11.1177 13.6061L10.6899 12.9294C10.5811 12.7583 10.3555 12.7039 10.1688 12.805C8.82327 13.5283 7.2055 13.6372 5.6655 12.9994C4.24994 12.4083 3.16105 11.1483 2.77216 9.67053C1.85439 6.24053 4.43661 3.12942 7.72661 3.12942C9.56216 3.12942 11.2422 4.1172 12.1522 5.66498H9.92772C9.82661 5.66498 9.73327 5.70386 9.66327 5.77386L8.89327 6.55164C8.65216 6.79275 8.82327 7.21275 9.17327 7.21275H14.6099C14.8277 7.22053 14.9988 7.04942 14.9988 6.83164V1.3872C14.9911 1.04498 14.5711 0.866086 14.3299 1.11498L13.5677 1.86942C13.4977 1.93942 13.4433 2.07164 13.4433 2.16498V4.73942C12.2377 2.7872 10.0833 1.55053 7.72661 1.55053C3.58105 1.55053 0.29883 5.32275 1.13105 9.60831Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboRedoSmall);
export default __webpack_public_path__ + "static/media/FBORedoSmall.bd2c03cf070a2cbf49afc3dfad36077c.svg";
export { ForwardRef as ReactComponent };